let _l10nString = {};
let localeString = "";
let isInitialized = false;
const moment = global.moment;

const initialize = (locale, l10n) => {
    localeString = locale;
    moment.locale(locale);

    for (let key in l10n)
        _l10nString[key] = {
            value: l10n[key],
            regex: RegExp(`\\b${key}\\b`)
        };

    isInitialized = true;
};

const translate = (value) => {
    if (typeof value !== "string")
        return value;

    var result = value;

    for (let key in _l10nString)
        result = result.replace(_l10nString[key].regex, _l10nString[key].value);

    return result;
};

const TranslationModule = {
    initialize: initialize,
    translate: translate,
    initialized: () => isInitialized,
    localeString: () => localeString
};

export default TranslationModule;
